module.exports = __webpack_public_path__ + "imgs/linkedin-white.bb7f8e89735bcb57535b46a63bf3d197.svg";